import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const ProductContext = createContext()

const ProductProvider = ({ children }) => {

    const { headers, toast, restaurantId } = useAuth();

    const getAllProducts = async (filter) => {
        try {
            const { modifiers, categories, limit, totalRenderedRecords, restaurant_id, filter: filterProducts, type } = filter

            const { data } = await axios.get(`${baseURL}/product/list?modifiers=${modifiers ? JSON.stringify(modifiers) : null}&categories=${categories ? JSON.stringify(categories) : null}&restaurant_id=${restaurant_id ? restaurant_id : null}&limit=${limit ? limit : null}&totalRenderedRecords=${totalRenderedRecords >= 0 ? totalRenderedRecords : null}&filter=${filterProducts !== '' && typeof filterProducts !== 'undefined' ? filterProducts : null}&type=${type ? type : 'all'}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Product', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const getProductByName = async (filter) => {
        try {
            const { name } = filter

            const { data } = await axios.get(`${baseURL}/product/product-by-name?name=${name}&restaurant_id=${restaurantId ? restaurantId : null}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            console.log('Error', error.message);
        }
    }

    const generateSKU = async (productDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/product/create/sku`, productDetail, { headers });
            if (data.error === false) {
                return data;
            }
        } catch (error) {
            console.log('Error', error.message);
        }
    }

    const createProduct = async (productDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/product/create`, productDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Product', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Product', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Product', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Product', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Product', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const getSingleProduct = async (id) => {
        try {
            let { data } = await axios.get(`${baseURL}/product/single-product/${id}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Product', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const updateProduct = async (id, productDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/product/update/${id}`, productDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Product', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Product', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Product', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Product', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Product', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const deleteProduct = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/product/delete/${id}`, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Product', detail: data.message, life: 3000 })
                }, 500);
            } else {
                toast.current?.show({ severity: 'error', summary: 'Product', detail: data.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Product', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    return (
        <ProductContext.Provider value={{ getAllProducts, createProduct, getSingleProduct, getProductByName, updateProduct, deleteProduct, generateSKU }}>
            {children}
        </ProductContext.Provider>
    )
}

const useProduct = () => useContext(ProductContext)

export { useProduct, ProductProvider }